import { useEffect, useState } from "react";
import axios from "api/axios";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PageShell, { SectionCard } from "components/patch/PageShell";
import SimpleTable from "components/patch/SimpleTable";

export default function RecurringDeductions() {
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({ pf_no: "", deduction_code: "" });
  const [form, setForm] = useState({
    pf_no: "",
    deduction_code: "",
    deduction_name: "",
    deduction_type: "continuous",
    amount: "",
    effective_from: "",
    effective_to: "",
  });
  const [uploadFile, setUploadFile] = useState(null);

  const load = async () => {
    const res = await axios.get("/pay-items/deductions", { params: { ...filters, per_page: 200 } });
    setRows(res.data?.data?.data || res.data?.data || []);
  };
  useEffect(() => {
    load();
  }, []);

  const create = async () => {
    await axios.post("/pay-items/deductions", {
      ...form,
      amount: Number(form.amount || 0),
      is_active: true,
      is_statutory: false,
      priority_protected: false,
    });
    setForm({
      pf_no: "",
      deduction_code: "",
      deduction_name: "",
      deduction_type: "continuous",
      amount: "",
      effective_from: "",
      effective_to: "",
    });
    await load();
  };

  const upload = async () => {
    if (!uploadFile) return;
    const fd = new FormData();
    fd.append("file", uploadFile);
    await axios.post("/pay-items/deductions/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    setUploadFile(null);
    await load();
  };

  return (
    <PageShell
      title="Recurring Deductions"
      subtitle="Manual entry plus bulk upload for continuous and frequency deductions."
    >
      <Grid container spacing={3}>
        <Grid item xs={12} lg={4}>
          <SectionCard title="Create Deduction">
            <MDBox display="flex" flexDirection="column" gap={2}>
              <MDInput
                label="PF No"
                value={form.pf_no}
                onChange={(e) => setForm({ ...form, pf_no: e.target.value })}
              />
              <MDInput
                label="Deduction Code"
                value={form.deduction_code}
                onChange={(e) => setForm({ ...form, deduction_code: e.target.value })}
              />
              <MDInput
                label="Deduction Name"
                value={form.deduction_name}
                onChange={(e) => setForm({ ...form, deduction_name: e.target.value })}
              />
              <MDInput
                label="Type"
                value={form.deduction_type}
                onChange={(e) => setForm({ ...form, deduction_type: e.target.value })}
              />
              <MDInput
                type="number"
                label="Amount"
                value={form.amount}
                onChange={(e) => setForm({ ...form, amount: e.target.value })}
              />
              <MDInput
                type="date"
                InputLabelProps={{ shrink: true }}
                label="Effective From"
                value={form.effective_from}
                onChange={(e) => setForm({ ...form, effective_from: e.target.value })}
              />
              <MDInput
                type="date"
                InputLabelProps={{ shrink: true }}
                label="Effective To"
                value={form.effective_to}
                onChange={(e) => setForm({ ...form, effective_to: e.target.value })}
              />
              <MDButton variant="gradient" color="success" onClick={create}>
                Save
              </MDButton>
            </MDBox>
          </SectionCard>
        </Grid>
        <Grid item xs={12} lg={8}>
          <SectionCard title="Bulk Upload & Register">
            <MDBox display="flex" gap={1} flexWrap="wrap" mb={2}>
              <MDButton
                variant="outlined"
                color="info"
                component="a"
                href={`${
                  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000/api"
                }/templates/recurring-deductions`}
                target="_blank"
                rel="noreferrer"
              >
                Sample Template
              </MDButton>
              <MDButton variant="outlined" component="label">
                Select Upload
                <input
                  hidden
                  type="file"
                  onChange={(e) => setUploadFile(e.target.files?.[0] || null)}
                />
              </MDButton>
              <MDButton variant="gradient" color="info" onClick={upload} disabled={!uploadFile}>
                Upload
              </MDButton>
            </MDBox>
            <Grid container spacing={2} mb={2}>
              <Grid item xs={12} md={6}>
                <MDInput
                  label="Filter PF No"
                  value={filters.pf_no}
                  onChange={(e) => setFilters({ ...filters, pf_no: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <MDInput
                  label="Filter Code"
                  value={filters.deduction_code}
                  onChange={(e) => setFilters({ ...filters, deduction_code: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <MDButton variant="gradient" color="dark" onClick={load}>
                  Load
                </MDButton>
              </Grid>
            </Grid>
            <SimpleTable
              columns={[
                { key: "pf_no", label: "PF No" },
                { key: "deduction_code", label: "Code" },
                { key: "deduction_name", label: "Name" },
                { key: "deduction_type", label: "Type" },
                { key: "amount", label: "Amount" },
                { key: "effective_from", label: "From" },
                { key: "effective_to", label: "To" },
              ]}
              rows={rows}
            />
          </SectionCard>
        </Grid>
      </Grid>
    </PageShell>
  );
}
